module.exports = __webpack_public_path__ + "static/4-e9ebaa3cdbdf5dd153ed75da26843b32.png";